import { useQuery } from "@tanstack/react-query";
import { api } from "../lib/api";

export interface EventProgram {
  day: string;
  dayLabel: string;
  title: string;
  description: string;
  job: string;
  xpMultiplier: number;
  event: string;
  eventTime: string;
  category: string;
}

export interface GuildEventRanking {
  rank: number;
  guildId: number;
  guild: string;
  points: number;
}

export interface BuildContestSubmission {
  player: string;
  project: string;
  world: string;
  x: number;
  y: number;
  z: number;
  votes: number;
}

export interface CommunityRetention {
  contestDate: string;
  contestOpen: boolean;
  contestReward: number;
  submissions: BuildContestSubmission[];
  lastBuildWinner: { player: string; project: string; votes: number; date: string };
  loyaltyMilestones: { days: number; title: string; money: number }[];
}

export interface EventsCalendar {
  date: string;
  timezone: string;
  season: string;
  current: EventProgram;
  week: EventProgram[];
  guildChallengeActive: boolean;
  guildRanking: GuildEventRanking[];
  lastWinner: { name: string; points: number; date: string };
  retention?: CommunityRetention;
}

export function useEventsCalendar() {
  return useQuery({
    queryKey: ["public", "events-calendar"],
    queryFn: ({ signal }) => api.get<EventsCalendar>("/public/events", { signal }),
    refetchInterval: 30_000,
    staleTime: 20_000,
    retry: 1,
  });
}
